import {absCenter, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {

  },

  imageDisplay: {
    container: {
      maxWidth: '100%',
      width: '160px',
      height: '200px',
      position: 'relative',
      border: '1px solid rgba(0,0,0,0.2)',
      background: '#fff'
    },
    image: {
      ...absCenter,
      padding: '8px',
    }
  },

  editingFlyerDisplay: {
    position: 'relative',
    display: 'inline-block',
  },
  flyerDeleteBtn: {
    position: 'absolute',
    left: 'auto',
    right: '-5px', top: '-5px',
    width: '32px',
    height: '32px',
    borderRadius: '100px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    fill: colors.error,
    background: '#fff'
  },
  flyerDeleteBtnHov: {
    background: colors.error,
    fill: '#fff'
  },
  deleteBtnSvg: {
    ...absCenter,
    display: 'block',
    width: '28px',
    height: '28px'
  },

  // empty
  emptyContainer: {
    position: 'relative',
    width: '100%',
    height: '200px',
  },
  emptyContent: {
    ...absCenter,
    textAlign: 'center',
    color: colors.black,
    fontSize: '1.8rem',
    fontWeight: 'bold',
  },
  emptyText: {
    margin: '2px 0 0',
  },
  emptySvg: {
    display: 'block',
    stroke: colors.black,
    width: '120px',
    height: '120px',
    margin: '0 auto',
    opacity: .2,
  }
}
